import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';

import { AppComponent } from './app.component';
import { CoreModule } from './_core/core.module';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { TranslateStore } from '@ngx-translate/core';
import { AppInitializerService } from './app.initializer';
import * as Sentry from '@sentry/angular';
import {MAT_RIPPLE_GLOBAL_OPTIONS} from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function appInit(appInitializerService: AppInitializerService) {
    return () => appInitializerService.initializeApp();
}
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        CoreModule,
        CommonModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(APP_ROUTES, {}),
        NgbModule,
    ],
    providers: [
        TranslateStore,
        { provide: APP_INITIALIZER, useFactory: appInit, deps: [AppInitializerService], multi: true },
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
